module.exports = __webpack_public_path__ + "img/cock-signal-lights.2846fb52.svg";